import { Locale } from 'chaika-enums';
export const mobileCardEntryPopup = {
    areYouSure: {
        [Locale.Ru]: 'Вы действительно хотите удалить запись?',
        [Locale.Am]: 'Իսկապե՞ս ուզում եք ջնջել գրառումը։',
        [Locale.En]: 'Are you really want to delete entry?',
        [Locale.Pt]: 'Você realmente deseja excluir a entrada?',
        [Locale.Ge]: 'ნამდვილად გსურთ ჩანაწერის წაშლა?',
    },
    returnFromArchive: {
        [Locale.Ru]: 'Вернуть из архива',
        [Locale.Am]: 'Վերադարձնել արխիվից',
        [Locale.En]: 'Return from archive',
        [Locale.Pt]: 'Retornar do arquivo',
        [Locale.Ge]: 'დაბრუნება არქივიდან',
    },
    moveToArchive: {
        [Locale.Ru]: 'В архив',
        [Locale.Am]: 'Ուղարկել արխիվ',
        [Locale.En]: 'Move to archive',
        [Locale.Pt]: 'Mover para o arquivo',
        [Locale.Ge]: 'არქივში გადატანა',
    },
    idAndEpisode: {
        [Locale.Ru]: 'ID и эпизод',
        [Locale.Am]: 'ID և էպիզոդ',
        [Locale.En]: 'ID and Episode',
        [Locale.Pt]: 'ID e Episódio',
        [Locale.Ge]: 'ID და ეპიზოდი',
    },
    openEntryProtocol: {
        [Locale.Ru]: 'Открыть протокол записи',
        [Locale.Am]: 'Բացել գրառման արձանագրությունը',
        [Locale.En]: 'Open entry protocol',
        [Locale.Pt]: 'Protocolo de entrada aberta',
        [Locale.Ge]: 'გახსენით შესვლის პროტოკოლი',
    },
    ofCourse: {
        [Locale.Ru]: 'Конечно',
        [Locale.Am]: 'Իհարկե',
        [Locale.En]: 'Of course',
        [Locale.Pt]: 'Claro',
        [Locale.Ge]: 'რა თქმა უნდა',
    },
    medicalCaseMenuText: {
        [Locale.Ru]: 'Если ничего из списка не подошло, можно ввести свое название',
        [Locale.Am]: 'Եթե ցանկից ոչինչ չհամապատասխանի, կարող եք մուտքագրել ձեր անվանումը',
        [Locale.En]: 'If nothing from the list is suitable, you can enter your own name',
        [Locale.Pt]: 'Se nada na lista for útil, você pode digitar seu próprio nome',
        [Locale.Ge]: 'თუ არ მოიძლია გამოიძლია შეიყვანოთ თქვენი სახელი',
    },
    medicalCaseMenuTextSecond: {
        [Locale.Ru]: 'Его увидит руководитель направления',
        [Locale.Am]: 'Այն կտեսնի ուղղության ղեկավարը',
        [Locale.En]: 'His/Her name will be seen by the head of the department',
        [Locale.Ge]: 'ის სახელი ნახება იქნება დაგეხმარელი განახლების მენეჯერი',
        [Locale.Pt]: 'Ele será visto pelo chefe do departamento',
    },
};
